<template>
<div class="bullet-point flex-row justify-between">
    <img
    class="bullet-point-img"
    referrerpolicy="no-referrer"
    src="@/assets/ceping114/bullet_point_img.png"
    />
    <span class="content">{{ content }}</span>
</div>
</template>

<script>
export default {
    name: "BulletPoint",
    props: {
      content: {
        type: String,
        required: true,
      },
    },
};
</script>

<style lang="scss" scoped>
@import "@s/common.scss";

.bullet-point {
    width: 7.44rem;
    .bullet-point-img {
        width: 0.187rem;
        height: 0.214rem;
        margin-top: 0.08rem;
    }
    .content {
        width: 7.04rem;
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: left;
        line-height: 0.427rem;
    }
}
</style>